import styles from './style.module.scss';
import { Descriptions, Spin } from 'antd';
import { Button, PageHeader } from 'components';
import { Link, useSearchParams, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { EditIcon } from 'icons';

import useContactRole from '../useContactRole';

const Single = () => {
  const { t } = useTranslation();
  let [searchParams] = useSearchParams();
  const { pathname } = useLocation();
  const { singleItem } = useContactRole(false);

  const isSuccessUpdatePage = searchParams.get('success') === 'true';

  const title = isSuccessUpdatePage
    ? t('RUOLO WAS SUCCESSFULLY UPDATED.')
    : t('RUOLO');

  return (
    <div>
      <PageHeader title={title}>
        <Link to={`${pathname}/edit`}>
          <Button iconMargin big type={'secondary'} icon={<EditIcon />}>
            {t('MODIFICA')}
          </Button>
        </Link>
      </PageHeader>
      <div className={styles.content}>
        <Descriptions column={1} bordered>
          <Descriptions.Item label={t('Titolo')}>
            {singleItem?.title || <Spin size={'medium'} />}
          </Descriptions.Item>
        </Descriptions>
      </div>
    </div>
  );
};

export default Single;
